import AbstractOperatorApplicationPlatform from "~/operatorApplication/ts/platform/AbstractOperatorApplicationPlatform";
import WebPlatformWindow, {FAVICON_ID} from "~/operatorApplication/ts/platform/web/WebPlatformWindow";
import AbstractPlatformWindow from "~/operatorApplication/ts/platform/AbstractPlatformWindow";
import AbstractPlatformNotification from "~/operatorApplication/ts/platform/AbstractPlatformNotification";
import WebPlatformNotification from "~/operatorApplication/ts/platform/web/WebPlatformNotification";
import AbstractPlatformUpdater from "~/operatorApplication/ts/platform/AbstractPlatformUpdater";
import {
    BRAND_METALK,
    BRAND_ONLINE_CHAT,
    BRAND_TALKME,
    BRAND_VERBOX
} from "~/operatorApplication/ts/data/OperatorApplicationBrands";
import {OperatorConfigStore} from "~/operatorApplication/ts/store/OperatorConfigStore";
import {
    OPERATOR_LOGGED_IN,
    OperatorApplicationEventManager
} from "~/operatorApplication/ts/OperatorApplicationEventManager";

export default class WebOperatorApplicationPlatform extends AbstractOperatorApplicationPlatform {
    constructor() {
        super();
        let hash = window.location.hash;
        if (hash) {
            let url = "http://fakehost.ru//" + hash.substr(1);
            this.handleAppUrl(url, true);
            OperatorApplicationEventManager.once(OPERATOR_LOGGED_IN, () => {
                this.handleAppUrl(url, true);
            });
        }
    }

    initBrand() {
        super.initBrand();
        document.title = OperatorConfigStore.brand.value.descr;
        let link = document.createElement("link");
        link.id = FAVICON_ID;
        link.rel = "shortcut icon";
        link.href = OperatorConfigStore.faviconSrc.value;
        document.head.appendChild(link);
    }


    protected createWindowInstance(): AbstractPlatformWindow {
        return new WebPlatformWindow();
    }

    get isNative(): boolean {
        return false;
    }

    get platformId(): string {
        return "web";
    }

    get platformDescr(): string {
        return "Web";
    }

    async getBrandId(): Promise<string> {
        let result = BRAND_ONLINE_CHAT;
        let hostname = window.location.hostname;
        if (hostname.indexOf("verbox.") !== -1) {
            result = BRAND_VERBOX;
        } else if (hostname.indexOf("talk-me.") !== -1 || hostname.indexOf("sms-uslugi.ru") !== -1) {
            result = BRAND_TALKME;
        } else if (hostname.indexOf("me-talk.") !== -1) {
            result = BRAND_METALK;
        }
        return result;
    }

    protected closeApplication() {
        window.close();
    }

    protected createNotificationInstance(): AbstractPlatformNotification {
        return new WebPlatformNotification();
    }

    openExternal(url: string) {
        try {
            new URL(url).protocol;
            window.open(url);
        } catch (e) {

        }
    }

    get isAutoStartAvailable(): boolean {
        return false;
    }

    isAutoStartEnabled(): Promise<boolean> {
        return Promise.resolve(false);
    }

    setAutoStartEnabled(value: boolean): Promise<void> {
        return Promise.resolve(undefined);
    }

    async getSystemIdleState(idleThreshold: number): Promise<"active" | "idle" | "locked" | "unknown"> {
        return "active";
    }

    async getSystemIdleTime(): Promise<number> {
        return 0;
    }

    get isSystemIdleStateAvailable(): boolean {
        return false;
    }

    protected createUpdaterInstance(): AbstractPlatformUpdater | null {
        return null;
    }

    public isPlatformCanDownload(): boolean {
        return false;
    }

    async getDefaultDownloadPath(): Promise<string> {
        return null;
    }

    download(url: string[]): void {
    }

    selectDirectory(defaultPath?: string): Promise<string> {
        return null;
    }

    isPreventContextMenuWithSelectionInChatHistory(hasSelection: boolean): boolean {
        return !hasSelection;
    }
}